module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

  
////   report---detallado_cuentas  detallado_altas   /////detallado_bajas  /////detallado_epigrafe

if(!_.size(attributes)){
    print("<p>" + lang.NO_RESULTS + "</p>");
}

__p+='\r\n    <table id="mainData" class="reportsTable">\r\n        ';

        var centinel = true;
_.each(attributes, function(item){
   
    
    if(report==="detallado_cuentas"){
////por cuentas 
 
         if(item.Noencurso){
            print(
            '<thead class="blac_ls_"><tr>' +
                '<td class="wid_5">' + lang["CODIGO"] + '</td>' +
                '<td class="wid_25">' + lang["NAME"] + '</td>' +
                '<td class="wid_5">Id</td>' +
                '<td class="wid_20">' + lang["DENOMINACION"] + '</td>' + 
                '<td class="wid_15">' + lang["RE_TOTALDEBE"] + '</td>' + 
                '<td class="wid_15">' + lang["REP_TOTALPATRINETO"] + '</td>' +
                '<td class="wid_15">' + lang["REP_TOTALHABER"] + '</td>' +
                '<td class="wid_15">' + lang["JURIDICOS_NATURALEZA"] + '</td>' +
                '</tr></thead>');
            print('<tbody>');

           var hidden = "";     

            for(var ind in item.Noencurso.goods){
                var goodxs = item.Noencurso.goods[ind];
 
                for(var i in goodxs){
                    var good = goodxs[i];
                
                
                    if(i==="0"){
                        print(
                            '<tr>'); 
                                print('<td><b>' +  good.code +'</b></td>');
                                print('<td></b>' + good.translation + '</b></td>' +
                                '<td>' + good.itemId + '</td>' +
                                '<td>' + good.denominacion + '</td>' +
                              
                                '<td class="text-left">' + good.costeTotal + '</td>' +
                                '<td class="text-left">' + good.vncTotal + '</td>' +
                                '<td class="text-left">' + good.economicos_amorAcumTotal + '</td>' +
                                '<td class="text-left">' + lang[good.laNaturalez] + '</td>' + 
                            '</tr>');
                    } else {
                        if(i != "totales"){
                            print(
                                    '<tr class=" ">' +
                                        '<td></td>' +
                                        '<td></td>' +
                                        '<td>' + good.itemId + '</td>' +
                                        '<td>' + good.denominacion + '</td>' +
                                    
                                        '<td class="text-left">' + good.costeTotal + '</td>' +
                                        '<td class="text-left">' + good.vncTotal + '</td>' +
                                        '<td class="text-left">' + good.economicos_amorAcumTotal + '</td>' +
                                        '<td class="text-left">' + lang[good.laNaturalez] + '</td>' + 
                                    '</tr>');

                             
                        }else{
                            
                            print(
                            '<tr>' +
                                '<td></td>' +
                                '<td colspan="3" class="text-left"><b>Total</b></td>' + 
                  
                                '<td class="text-left"><b>' + good.totalCoste + '</b></td>' +
                                '<td class="text-left"><b>' + good.totalVNC + '</b></td>' +
                                '<td class="text-left"><b>' + good.totalAcumulada + '</b></td>' +
                       
                            '</tr>');
                        } 
                    }   
                }  
            }  
         }

        if(item.ENencurso){

            print(
                '<tr>' +
                '<td colspan="8"><b>EN CURSO</b></td>' + 
            '</tr>');


            for(var indS in item.ENencurso.goods){
                var goodxsS = item.ENencurso.goods[indS];

                for(var i in goodxsS){
                    var good = goodxsS[i];
                
                
                    if(i==="0"){
                        print(
                            '<tr>'); 
                                print('<td><b>' +  good.code_enCurso +'</b></td>');
                                print('<td></b>' + good.translation + '</b></td>' +
                                '<td>' + good.itemId + '</td>' +
                                '<td>' + good.denominacion + '</td>' +
                             
                                '<td class="text-left">' + good.costeTotal + '</td>' +
                                '<td class="text-left">' + good.vncTotal + '</td>' +
                                '<td class="text-left">' + good.economicos_amorAcumTotal + '</td>' +
                                '<td class="text-left">' + lang[good.laNaturalez] + '</td>' + 
                            '</tr>');
                    } else {
                        if(i != "totales"){
                            print(
                                    '<tr class=" ">' +
                                        '<td></td>' +
                                        '<td></td>' +
                                        '<td>' + good.itemId + '</td>' +
                                        '<td>' + good.denominacion + '</td>' +
                            
                                        '<td class="text-left">' + good.costeTotal + '</td>' +
                                        '<td class="text-left">' + good.vncTotal + '</td>' +
                                        '<td class="text-left">' + good.economicos_amorAcumTotal + '</td>' +
                                        '<td class="text-left">' + lang[good.laNaturalez] + '</td>' + 
                                    '</tr>');

                              
                        }else{
                           
                            print(
                            '<tr>' +
                                '<td> </td>' +
                                '<td colspan="3" class="text-left"><b>Total</b></td>' + 
                
                                '<td class="text-left"><b>' + good.totalCoste + '</b></td>' +
                                '<td class="text-left"><b>' + good.totalVNC + '</b></td>' +
                                '<td class="text-left"><b>' + good.totalAcumulada + '</b></td>' +
                
                            '</tr>');
                        } 
                    }   
                }  
            }
  
        }
        



        
        if(item.totals){
         
            print(
            '<tr>' +
                '<td> </td>' +
                '<td colspan="3" class="text-left"><b>Total</b></td>' + 

                '<td class="text-left"><b>' + item.totals.totinvent + '</b></td>' +
                '<td class="text-left"><b>' + item.totals.totnetocont + '</b></td>' +
                '<td class="text-left"><b>' + item.totals.totamorti + '</b></td>' +
            '</tr>');
     
        }

        

  }else if(report==="detallado_epigrafe"){
    //// por epigrafe 
 
         if(item.Noencurso){
            print(
            '<thead class="blac_ls_"><tr>' +
                '<td>' + lang["CODIGO"] + '</td>' +
                '<td>' + lang["NAME"] + '</td>' +
                '<td>Id</td>' +
                '<td>' + lang["DENOMINACION"] + '</td>' + 
                '<td>' + lang["RE_TOTALDEBE"] + '</td>' + 
 
                '</tr></thead>');
            print('<tbody>');

           var hidden = "";     

            for(var ind in item.Noencurso.goods){
                var goodxs = item.Noencurso.goods[ind];
 
                for(var i in goodxs){
                    var good = goodxs[i];
                
                
                    if(i==="0"){
                        print(
                            '<tr>'); 
                                print('<td><b>' +  good.code +'</b></td>');
                                print('<td></b>' + good.translation + '</b></td>' +
                                '<td>' + good.itemId + '</td>' +
                                '<td>' + good.denominacion + '</td>' +
                              
                                '<td class="text-left">' + good.costeTotal + '</td>' + 
                            '</tr>');
                    } else {
                        if(i != "totales"){
                            print(
                                    '<tr class=" ">' +
                                        '<td></td>' +
                                        '<td></td>' +
                                        '<td>' + good.itemId + '</td>' +
                                        '<td>' + good.denominacion + '</td>' +
                                    
                                        '<td class="text-left">' + good.costeTotal + '</td>' + 
                                    '</tr>');

                            
                        }else{
                           
                            print(
                            '<tr>' +
                                '<td> </td>' +
                                '<td colspan="3" class="text-left"><b>Total</b></td>' + 
                  
                                '<td class="text-left"><b>' + good.totalCoste + '</b></td>' + 
                            '</tr>');
                        } 
                    }   
                }  
            }  
         }

        if(item.ENencurso){

            print(
                '<tr>' +
                '<td colspan="7"><b>EN CURSO</b></td>' + 
            '</tr>');


            for(var indS in item.ENencurso.goods){
                var goodxsS = item.ENencurso.goods[indS];

                for(var i in goodxsS){
                    var good = goodxsS[i];
                
                
                    if(i==="0"){
                        print(
                            '<tr>'); 
                                print('<td><b>' +  good.code +'</b></td>');
                                print('<td></b>' + good.translation + '</b></td>' +
                                '<td>' + good.itemId + '</td>' +
                                '<td>' + good.denominacion + '</td>' +
                             
                                '<td class="text-left">' + good.costeTotal + '</td>' + 
                            '</tr>');
                    } else {
                        if(i != "totales"){
                            print(
                                    '<tr class=" ">' +
                                        '<td></td>' +
                                        '<td></td>' +
                                        '<td>' + good.itemId + '</td>' +
                                        '<td>' + good.denominacion + '</td>' +
                            
                                        '<td class="text-left">' + good.costeTotal + '</td>' + 
                                    '</tr>');

                            
                        }else{
                            
                            print(
                            '<tr>' +
                                '<td> </td>' +
                                '<td colspan="3" class="text-left"><b>Total</b></td>' + 
                
                                '<td class="text-left"><b>' + good.totalCoste + '</b></td>' + 
                            '</tr>');
                        } 
                    }   
                }  
            }

            
        }

         
        if(item.totals){
         
            print(
            '<tr>' +
                '<td> </td>' +
                '<td colspan="3" class="text-left"><b>Total</b></td>' + 

                '<td class="text-left"><b>' + item.totals.totinventa + '</b></td>' + 
            '</tr>');
     
        }

        
         
        
    }else if(report==="detallado_altas"){
        ////altas por epigrafe
 
        
         if(item.altasListado){
            print(
            '<thead class="blac_ls_  bla_ss_wired"><tr>' +
                '<td class="wid_5">' + lang["CODIGO"] + '</td>' +
                '<td class="wid_15">' + lang["NAME"] + '</td>' +
                '<td class="wid_5">Id</td>' +
                '<td class="wid_15">' + lang["DENOMINACION"] + '</td>' + 
                '<td class="wid_10">' + lang["CATASTRALES_VALOR"] + '</td>' +  
                '<td class="wid_20">' + lang["JURIDICOS_TIPOADQUISICION"] + '</td>' +
                '<td class="wid_5">' + lang["LABE_ES_RAZONABL"] + '</td>' +
                '<td class="wid_5">' + lang["LABE_ES_MEJORR"] + '</td>' +
                '<td class="wid_14">' + lang["EPIGRAFE"] + '</td>' +
                '<td class="wid_6">' + lang["LABE_FECH_VALOR_R"] + '</td>' +
                '</tr></thead>');
            print('<tbody>');

           var hidden = "";     

            for(var ind in item.altasListado.goods){
                var goodxs = item.altasListado.goods[ind];
 
                for(var i in goodxs){
                    var good = goodxs[i];
                 
                    if(i==="0"){
                        print(
                            '<tr>'); 
                                print('<td><b>' +  good.code +'</b></td>');
                                print('<td></b>' + good.translation + '</b></td>' +
                                '<td>' + good.itemId + '</td>' +
                                '<td>' + good.denominacion + '</td>' + 
                                '<td class="text-left">' + good.costeTotal + '</td>' + 
                                '<td class="text-left">' + tipoAdquisicion[good.tipoAdquisici] + '</td>' );

                                if(good.esMejora_ == 1){
                                    print('<td class="text-left">--</td>');
                                    print('<td class="text-left">' + lang["YES"] + '</td>');
                                }else{
                                    
                                    if(good.isRazonable_ == 1){
                                        print('<td class="text-left">' + lang["YES"] + '</td>');
                                    }else{
                                        print('<td class="text-left">' + lang["NO"] + '</td>');
                                    }
                                    print('<td class="text-left">' + lang["NO"] + '</td>');
                                }
                                 
                                print( '<td class="text-left">' + listEpigrafes[good.epigraph_] + '</td>' +
                                '<td class="text-left">' + good.fechaAdquisicRazonable_ + '</td>' +
                            '</tr>');
                    } else {

                        if(i != "totales"){
                            
                            print(
                                    '<tr class="  ">' +
                                        '<td></td>' +
                                        '<td></td>' +
                                        '<td>' + good.itemId + '</td>' +
                                        '<td>' + good.denominacion + '</td>' + 
                                        '<td class="text-left">' + good.costeTotal + '</td>' + 
                                        '<td class="text-left">' + tipoAdquisicion[good.tipoAdquisici] + '</td>' );

                                        if(good.esMejora_ == 1){
                                            print('<td class="text-left">--</td>');
                                            print('<td class="text-left">' + lang["YES"] + '</td>');
                                        }else{
                                            if(good.isRazonable_ == 1){
                                                print('<td class="text-left">' + lang["YES"] + '</td>');
                                            }else{
                                                print('<td class="text-left">' + lang["NO"] + '</td>');
                                            }
                                            print('<td class="text-left">' + lang["NO"] + '</td>');
                                        }
                                        
                                        
                                    print('<td class="text-left">' + listEpigrafes[good.epigraph_] + '</td>' +
                                        '<td class="text-left">' + good.fechaAdquisicRazonable_ + '</td>' +
                                    '</tr>');

                              
                        }else{
                            
                            print(
                            '<tr>' +
                                '<td> </td>' +
                                '<td colspan="3" class="text-left"><b>Total</b></td>' +  
                                '<td class="text-left"><b>' + good.totalCoste + '</b></td>' + 
                                '<td colspan="2"  class="text-left"><b></b></td>' +
                                '<td colspan=""  class="text-left"><b></b></td>' +
                                '<td colspan=""  class="text-left"><b></b></td>' +
                                '<td colspan=""  class="text-left"><b></b></td>' +
                                '<td colspan=""  class="text-left"><b></b></td>' +
                            '</tr>');
                        } 
                    }   
                }  
            }  

            if(item.altasListado.totalTotal){
                print(
                '<tr>' +
                    '<td> </td>' +
                    '<td colspan="3" class="text-left"><b>T. Total</b></td>' +  
                    '<td class="text-left"><b>' + item.altasListado.totalTotal + '</b></td>' + 
                    '<td colspan="2"  class="text-left"><b></b></td>' +
                    '<td colspan=""  class="text-left"><b></b></td>' +
                    '<td colspan=""  class="text-left"><b></b></td>' +
                    '<td colspan=""  class="text-left"><b></b></td>' +
                    '<td colspan=""  class="text-left"><b></b></td>' +
                '</tr>');
            }          
         }

  }else if(report==="detallado_bajas"){
        /////BAJAS X EPIGRAFE 

         if(item.bajasListado){

            print(
            '<thead class="blac_ls_  bla_ss_wired"><tr>' +
                '<td class="wid_5">' + lang["CODIGO"] + '</td>' +
                '<td class="wid_15">' + lang["NAME"] + '</td>' +
                '<td class="wid_5">Id</td>' +
                '<td class="wid_20">' + lang["DENOMINACION"] + '</td>' +  
                '<td class="wid_15">' + lang["EPIGRAFE"] + '</td>' +
                '<td class="wid_5">' + lang["FECHA_BAJA"] + '</td>' +
                '<td class="wid_15">' + lang["MOTIVO_BAJA"] + '</td>' +
                '<td class="wid_10">' + lang["RE_TOTALDEBE"] + '</td>' +
                '<td class="wid_6">' + lang["REP_TOTALPATRINETO"] + '</td>' +
                '<td class="wid_6">' + lang["REP_TOTALHABER"] + '</td>' +
                '</tr></thead>');
            print('<tbody>');

         
           var hidden = "";     

            for(var ind in item.bajasListado.goods){
                var goodxs = item.bajasListado.goods[ind];
 
 
                

                for(var i in goodxs){
                    var good = goodxs[i];
                 
                    if(i==="0"){
                        print(
                            '<tr>'); 
                                print('<td><b>' +  good.code +'</b></td>');
                                print('<td></b>' + good.translation + '</b></td>' +
                                '<td>' + good.itemId + '</td>' +
                                '<td>' + good.denominacion + '</td>' +  
                                '<td class="text-left">' + listEpigrafes[good.epigraph_] + '</td>' +
                                '<td class="text-left">' + good.fechaBajaDate + '</td>' + 
                                '<td class="text-left">' + good.motivoBaja + '</td>' +
                                '<td class="text-left">' + good.costeTotal + '</td>' +
                                '<td class="text-left">' + good.vncTotal + '</td>' +
                                '<td class="text-left">' + good.amorAcumTotal + '</td>' +
                            '</tr>');
                    } else {
  
                        if(i != "totales"){
                         
                            
                            print(
                            '<tr class="  ">' +
                                '<td></td>' +
                                '<td></td>' +
                                '<td>' + good.itemId + '</td>' +
                                '<td>' + good.denominacion + '</td>' +   
                                '<td class="text-left">' + listEpigrafes[good.epigraph_] + '</td>' + 
                                '<td class="text-left">' + good.fechaBajaDate + '</td>' +
                                '<td class="text-left">' + good.motivoBaja + '</td>' +
                                '<td class="text-left">' + good.costeTotal + '</td>' +
                                '<td class="text-left">' + good.vncTotal + '</td>' +
                                '<td class="text-left">' + good.amorAcumTotal + '</td>' +
                            '</tr>');

                              
                              
                        }else{
                                
                            print(
                                '<tr>' +
                                    '<td> </td>' +
                                    '<td colspan="3" class="text-left"><b>Total</b></td>' +  
                                    '<td class="text-left"><b></b></td>' + 
                                    '<td class="text-left"><b></b></td>' + 
                                    '<td class="text-left"><b></b></td>' + 
                                    '<td class="text-left">' + good.totalCoste + '</td>' +
                                    '<td class="text-left">' + good.totalVNC + '</td>' + 
                                    '<td class="text-left">' + good.totalAmortiza + '</td>' + 
                                '</tr>');
                            
                        } 

                    }   
                }  
            }  

            if(item.bajasListado.totalTotal){
                print(
                '<tr>' +
                    '<td> </td>' +
                    '<td colspan="3" class="text-left"><b>T. Total</b></td>' +  
                    '<td class="text-left"><b></b></td>' + 
                    '<td  class="text-left"><b></b></td>' +
                    '<td colspan=""  class="text-left"><b></b></td>' +
                    '<td colspan=""  class="text-left"><b>' + item.bajasListado.totalTotal + '</b></td>' +
                    '<td colspan=""  class="text-left"><b>' + item.bajasListado.totalVNC + '</b></td>' +
                    '<td colspan=""  class="text-left"><b>' + item.bajasListado.totalAMORT + '</b></td>' +
                '</tr>');
            }

        }

 
        
    }
    
});

__p+='\r\n\r\n    </table>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/report/regionDetalladosView.ejs
// module id = 443
// module chunks = 0